import { render } from "./Snackbar.vue?vue&type=template&id=74bf49dc&scoped=true"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=74bf49dc&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bf49dc"]])

export default __exports__